<template>
	<div
		v-cloak
		v-if="!showAppLoader"
		id="app-container"
		:class="{ 'is-loading': showAppLoader, 'is-loaded': !showAppLoader}"
	>
		<router-view></router-view>
	</div>
	<app-loader id="loading-wrapper"></app-loader>
	<scroll-top></scroll-top>
</template>

<script>
import AppLoader from '@components/ui/AppLoader.vue'
import ScrollTop from '@components/ui/ScrollTop'

// Export component
export default {
	components: {
		AppLoader,
		ScrollTop
	},
	// Data
	data: () => ({}),
	// Methods
	methods: {}
};
</script>